import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {withSnackbar} from "notistack";
import {withRouter} from "react-router";
import {Styles} from "../../../../config/design/styles";
import {connect, setStore} from "trim-redux";
import SearchRoundedIcon from '@material-ui/icons/SearchRounded';
import IconButton from "@material-ui/core/IconButton/IconButton";
import Drawer from "@material-ui/core/Drawer";
import TextField from "@material-ui/core/TextField/TextField";
import {Translate} from "../../../../config/Translate";
import {ListItem} from "@material-ui/core";
import List from "@material-ui/core/List/List";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction/ListItemSecondaryAction";
import ChevronLeftRoundedIcon from "@material-ui/icons/ChevronLeftRounded";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";

class PlayerPage extends React.Component {
    state = {
        open:false,
        query:'',
        result:[],
    };
    classes = this.props.classes;
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.result !== this.state.result){
            this.setState({
                result:this.props.result
            })
        }
    }

    toggleDrawer(){
        let{open} = this.state;
        this.setState({
            open:!open
        })
    }
    handleSearch(){
        let {query} = this.state;
        this.props.handleSearch(query)
    }
    handleClick(cfi){
        this.props.handleClick(cfi);
        this.toggleDrawer();
    }
    render(){
        let {open,query,result} = this.state;
        return (
            <div>
                <Tooltip arrow title={Translate.search}>
                    <IconButton
                        onClick={() => this.toggleDrawer()}
                        size="small"
                    >
                        <SearchRoundedIcon/>
                    </IconButton>
                </Tooltip>
                <Drawer className={this.classes.readerDrawer} anchor={"right"} open={open} onClose={() => this.toggleDrawer()}>
                    <div className="search-holder">
                        <TextField
                            autoFocus
                            variant="outlined"
                            fullWidth
                            size="small"
                            className="search-input"
                            label={Translate.searchInBook}
                            helperText={Translate.atLeast5Character}
                            value={query}
                            onChange={(e) => this.setState({query:e.target.value})}
                            InputProps={{
                                endAdornment: (
                                    <IconButton
                                        onClick={() => this.handleSearch()}
                                        size="small"
                                        color="secondary"
                                        disabled={query.length < 5}
                                    >
                                        <SearchRoundedIcon/>
                                    </IconButton>
                                ),
                            }}
                        />
                    </div>

                    <List className="listing">
                        {
                            result.map((item,index) => (
                                <ListItem
                                    key={index}
                                    button
                                    onClick={() => this.handleClick(item.cfi)}
                                >
                                    <ListItemText
                                        primary={item.excerpt}
                                    />
                                    <ListItemSecondaryAction>
                                        <ChevronLeftRoundedIcon/>
                                    </ListItemSecondaryAction>
                                </ListItem>
                            ))
                        }

                    </List>


                </Drawer>
            </div>

        );
    }
}
const mstp = state => ({
    user: state.user,
});
export default withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(PlayerPage))));